import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const DescriptionWrapper = styled("div")(() => ({
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "column",
}));

export const Description = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  color: colors.gray800,
}));

export const Warning = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  lineHeight: "24px",
  color: colors.error500,
  fontStyle: "italic",
}));
